/*
 The typing of this function has two purposes

 1. only accept an object as the argument (and the pathContext
 string but that's just for the recursion really and is not meant
 to ever be used by a user of this function)

 2. serves an identity function for auto-completion on the returned
 object (same type as passed obj)
 */
const populateObjectUniquely = <T extends { [ prop: string ]: any }> (
  object: T,
  pathContext: string = '',
): T => {
  const uniquelyPopulated = {} as T
  for (const key in object) {
    if (!object.hasOwnProperty(key)) continue

    if (typeof object[ key ] === 'object') {
      uniquelyPopulated[ key ] = populateObjectUniquely(
        object[ key ],
        pathContext + key + '.',
      )
    } else {
      uniquelyPopulated[ key ] = pathContext + key
    }
  }

  return uniquelyPopulated
}

export default populateObjectUniquely



// WEBPACK FOOTER //
// ./src/utils/populate-object-uniquely/populate-object-uniquely.ts